import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, map, Observable } from 'rxjs';

import { TimeEntryCategory } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class TimeEntryCategoriesService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  get(loader: string): Observable<TimeEntryCategory[]> {
    this.loadersService.show(loader);

    const url = `${this.baseUrl}/time-entries`;
    return this.http.get<TimeEntryCategory[]>(url).pipe(finalize(() => this.loadersService.hide(loader)));
  }

  add(loader: string, dto: TimeEntryCategory): Observable<TimeEntryCategory> {
    this.loadersService.show(loader);
    return this.http
      .post<TimeEntryCategory>(this.baseUrl + '/time-entries', dto)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  edit(loader: string, dto: TimeEntryCategory): Observable<TimeEntryCategory> {
    this.loadersService.show(loader);
    return this.http
      .put<TimeEntryCategory>(this.baseUrl + '/time-entries', dto)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  batchUpdate(
    loader: string,
    dto: { timeEntryCategories: TimeEntryCategory[]; timeEntryCategoryIdsToDelete: string[] }
  ): Observable<void> {
    this.loadersService.show(loader);
    return this.http
      .put<void>(this.baseUrl + '/time-entries/batch-update', dto)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  delete(loader: string, id: string): Observable<boolean> {
    this.loadersService.show(loader);
    return this.http.delete(`${this.baseUrl}/time-entries/${id}`, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }
}
